module.exports = __webpack_public_path__ + "img/CloudsAndSnowRain.647fa66c.png";